export * from "./coupe-icon.component";
